export enum ThroneEnum {
  //  0:功能关闭;1:蓄力阶段;2: 争夺阶段
  close = 0,
  load = 1,
  ongoing,
}
export enum ModalTypeEnum {
  main = 1,
  record,
  rule,
}
export interface winner_type {
  id: number
  zyId: string
  avatar: string
  name: string
}
export interface king_reward_type extends winner_type {
  coin_nums: number
}
export enum throne_status {
  // 0:功能关闭;1:蓄力阶段;2: 争夺阶段
  close = 0,
  load = 1,
  fight = 2,
}
// 王座争夺战相关的信息
export interface throne_info {
  actId?: number
  status: throne_status

  poolSize: number // 奖池大小

  poolProgress: number // 蓄力进度

  countRounds: number // 争夺剩余的轮次
  kingNeed: number // 争夺王座需要的钱
  king: winner_type // 当前的争夺冠军用户信息
  startDate: string // 开始时间
  endDate: string // 结束时间
  roundLimit: 10 // 王座轮次最大值
  roundAddPer: 3 // 每次增加轮次的次数
  kingHoldNeedDecrRatio: number // 王座衰减
}
